module.exports = __webpack_public_path__ + "static/media/promineo-icon.f7599a20.svg";